import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { ProgressBar } from "react-bootstrap";
import { base, s3base } from "api.js";
// import { Radio } from '@mui/material';
import Sound from 'react-sound';
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
import "components/custom.css";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";

const McqSingle = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  // const [isBlocked, setIsBlocked] = useState(false);
  // const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [selectedValue, setSelectedValue] = useState('');
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(90);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  // const [stopped, setStopped] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [questionAudio, setQuestionAudio] = useState(null);           // current audio URL
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [audioFinished, setAudioFinished] = useState(false);          // to block changes after finish
  const [currentAudioIndex, setCurrentAudioIndex] = useState(null);
  const [audioRetryCount, setAudioRetryCount] = useState(0);
  const intervalIdRef = useRef(intervalId);
  const recordIdRef = useRef(recordId);
  
  useEffect(() => {
    intervalIdRef.current = intervalId;
    recordIdRef.current = recordId;
  }, [intervalId, recordId]);

  useEffect(() => {
    if (!props.answer) {
      const newIntervalId = setInterval(timer, 1000);
      setIntervalId(newIntervalId);
      props.updateQuestionAudioUrlInPractice(`${s3base}${props.data.media_link}`);
    }
  }, []);

  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);
        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setIsRecording(false);
        setSecondCount(10);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setSoundStatus(true);
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart]);

  useEffect(() => {
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  const selectAndTryAudio = useCallback((index) => {
    const { question_audios } = props.data;
    if (question_audios && question_audios.length > 0 && index < question_audios.length) {
      const selected = question_audios[index];
      setQuestionAudio(`${s3base}/${selected.value}`);
      setDefaultSelectedVoice(selected.label);
      setCurrentAudioIndex(index);
    }
  }, [props.data]);

  const handleAudioError = useCallback((errorCode, description) => {
    console.log("Got the error", errorCode, description);
    const { question_audios, media_link } = props.data;
    
    if (!question_audios || question_audios.length === 0) {
      console.error("No alternative audio available, using media_link");
      setQuestionAudio(`${s3base}${media_link}`);
      setCurrentAudioIndex(null);
      setSoundKey(prevKey => prevKey + 1);
      return;
    }

    if (audioRetryCount >= question_audios.length) {
      console.error("All audios failed, falling back to media_link");
      setQuestionAudio(`${s3base}${media_link}`);
      setCurrentAudioIndex(null);
      setSoundKey(prevKey => prevKey + 1);
      setAudioRetryCount(0);
      return;
    }

    const nextIndex = (currentAudioIndex + 1) % question_audios.length;
    setAudioRetryCount(prevCount => prevCount + 1);
    setSoundKey(prevKey => prevKey + 1);
    
    setTimeout(() => {
      selectAndTryAudio(nextIndex);
    }, 100);
  }, [props.data, currentAudioIndex, audioRetryCount, selectAndTryAudio]);

  const getQuestionAudio = useCallback((data) => {
    if (!data) {
      return { question_audio_local: null, defaultSelectedVoice_local: null };
    }

    let question_audio_local = null;
    let defaultSelectedVoice_local = null;

    // Multiple voices available → random selection
    if (data.question_audios && data.question_audios.length > 0) {
      const x = Math.floor(
        Math.random() * Math.min(6, data.question_audios.length)
      );
      const selected = data.question_audios[x];
      question_audio_local = `${s3base}/${selected.value}`;
      defaultSelectedVoice_local = selected.label;
      setCurrentAudioIndex(x);
      setAudioRetryCount(0);
    }
    // Fallback to old single audio
    else if (data.media_link) {
      question_audio_local = `${s3base}${data.media_link}`;
    }

    return { question_audio_local, defaultSelectedVoice_local };
  }, []);

  useEffect(() => {
    if (!props.data) return;

    const currentId = props.data.id;

    // New question or restart
    if (!questionId || questionId !== currentId || props.restart) {
      // Clean up intervals
      if (intervalIdRef.current) clearInterval(intervalIdRef.current);
      if (recordIdRef.current) clearInterval(recordIdRef.current);

      const { question_audio_local, defaultSelectedVoice_local } =
        getQuestionAudio(props.data);

      setQuestionAudio(question_audio_local);
      setDefaultSelectedVoice(defaultSelectedVoice_local);
      setQuestionId(currentId);
      setCorrectFlag(true);
      setRecordCount(0);
      setSoundPer(0);
      setSecondCount(10);
      setSoundStatus(true);
      setAudioFinished(false);
      setSoundKey((prev) => prev + 1);

      // Notify parent about current audio (if needed)
      if (question_audio_local && props.updateQuestionAudioUrlInPractice) {
        props.updateQuestionAudioUrlInPractice(question_audio_local);
      }

      // Start countdown again
      setReset(true);
    }
  }, [props.data?.id, props.restart, getQuestionAudio]);

  const changeAudio = useCallback(
    (selected) => {
      // Prevent change after audio finished
      if (audioFinished || props.answer) return;

      if (!props.data?.question_audios) return;

      const selectedAudio = props.data.question_audios.find(
        (audio) => audio.label === selected.label
      );

      if (!selectedAudio) return;

      const newAudioUrl = `${s3base}/${selectedAudio.value}`;

      // Reset audio state
      setQuestionAudio(newAudioUrl);
      setDefaultSelectedVoice(selected.label);
      setCurrentAudioIndex(selectedAudio);
      setAudioRetryCount(0);
      setSoundKey((prev) => prev + 1); // Force Sound re-mount
      setSoundStatus(true);
      setAudioFinished(false);
      setSoundPer(0);

      // Restart countdown from beginning (user will hear new audio from start)
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
      // setSecondCount(0); // or your desired preparation time
      setReset(true);
    },
    [props.data?.question_audios, audioFinished, props.answer]
  );

  const timer = () => {
    setSecondCount(prevCount => {
      if (prevCount <= 1) {
        clearInterval(intervalIdRef.current);
      return 0
      }
      return prevCount - 1;
    });
  };

  // const stopTest = () => {
  //   props.nextQuestion(resultObj);
  //   // setStopped(true);
  // };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    setAudioFinished(true);
    props.soundChecked();
    props.showResult();
     if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  const handleSongPlaying = (obj) => {
    setSoundPer(obj.position * 100 / obj.duration);
  };

  // const timerRecord = () => {
  //   setRecordCount(prevCount => {
  //     if (prevCount === 40) {
  //       clearInterval(recordIdRef.current);
  //       stop();
  //     }
  //     return prevCount + 1;
  //   });
  // };

  const skip = () => {
    clearInterval(intervalIdRef.current);
    setSecondCount(0);
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const handleChange = (event) => {
    props.showResult();
    let correct = props.data.option.filter(function (item) {
      return item.correct == 1;
    })[0].id;
    props.submit({ 'answer': event.target.value, 'correct': correct }, true);
    setSelectedValue(event.target.value);
    setResultObj({ 'answer': event.target.value, 'correct': correct });
  };

  const updateCorrect = () => {
    let correct = props.data.option.filter(function (item) {
      return item.correct == 1;
    })[0].id;
    props.submit({ 'answer': '', 'correct': correct });
    setCorrectFlag(false);
    setResultObj({ 'answer': '', 'correct': correct });
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey(prevKey => prevKey + 1);
    setPlaybackSpeed(speed);
  };

  const playingQuestionSectionLabel = () => {
    let status = '';
      if (props.answer) {
    return 'Question audio finished.';
  }
    if (!isRecording) {
      if (secondCount !== 0 && soundStatus === true) {
        console.log("The SecondCount : ",secondCount);
        status = `Beginning in ${secondCount} seconds`;
      } else if (secondCount === 0 && soundStatus) {
        status = 'Playing question audio...';
      } else {
        status = 'Question audio finished.';
      }
    } else {
      status = 'Question audio finished.';
    }
    return status;
  };

  const showSkipAudioWaitButton = () => {
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount !== 0 && blobURL === '' && !isRecording) {
      button = true;
    }

    return button;
  };

  
  const showSkipAudioButton = () => {
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount === 0 && soundStatus === true && !isRecording) {
      button = true;
    }

    return button;
  };

  const stopAudio = () => {
    setSoundStatus(false);
     if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  const playAudio = () => {
    const { data, resultMode } = props;

    let audio = false;
    if (data && !resultMode && soundStatus && secondCount === 0) {
      audio = true;
    }

    return audio;
  };

  const optionResponseClass = (item) => {
    let class_name = "";

    const { answer } = props;
    const selectedValueInt = parseInt(selectedValue);

    return answer && (item.correct === 1 ? (selectedValueInt === item.id ? "success-wrapper" : "normal-wrapper") : (selectedValueInt === item.id) ? "error-wrapper" : "");
  };

  // let questionText = "";
  let questionText = useMemo(() => {
      return props.data?.question_mcq || "";
    }, [props.data?.question_mcq]); 

  // if (props.restart) {
  //   props.restartQue();
  // }
   useEffect(() => {
        if (props.restart) {
          props.restartQue();
        }
      }, [props.restart]);
  // if (props.stopRecording) {
  //   stopTest();
  // }

  // if (props.data) {
  //   questionText = props.data.question_mcq;
  //   if (correctFlag) {
  //     updateCorrect();
  //   }
  // }
  useEffect(() => {
      if (props.data && correctFlag) {
        updateCorrect();
      }
    }, [props.data, correctFlag]);

  // if (reset) {
  //   const newIntervalId = setInterval(timer, 1000);
  //   setIntervalId(newIntervalId);
  //   setReset(false);
  // }

  useEffect(() => {
      if(reset)
        {
          if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
    }
const newIntervalId = setInterval(timer, 1000);
    setIntervalId(newIntervalId);
    setReset(false);
      }
  },[reset])

  const { data, resultMode, answer } = props;

  // Handle double click to deselect
  const handleDoubleClick = useCallback((event) => {
    if (!!answer) return; // Don't allow if answer is submitted
    
    if (selectedValue) {
      setSelectedValue('');
      let correct = props.data.option.filter(function (item) {
      return item.correct == 1;
    })[0].id;
      // Submit deselected state
      if (props.submit) {
        props.submit({
          answer: '',
          correct: correct
        }, true);
      }
    }
  }, [selectedValue, answer, props.submit]);  

  return (
    <>
      {playAudio() && questionAudio &&
        <Sound
          url={questionAudio}
          playStatus={answer || !props.soundStatusMain ? Sound.status.STOPPED : Sound.status.PLAYING}
          onFinishedPlaying={handleSongFinishedPlaying}
          onPlaying={handleSongPlaying}
          onError={handleAudioError}
          volume={volume}
          playbackRate={playbackSpeed}
          key={soundKey}
        />
      }

      <div className="pmw-tabs-section d-flex align-items-start justify-content-center pmw-outer-wrapper recorded-wrapper challenge-content-wrapper visibility-visible mx-0">
        {/* width-50 */}
        <div className="recorded-section h-100 m-0 p-0 border-0">
          <div className="recorded-content">
            <div className="row">
              <div className="col-12">
                <ul className="recorded-list">
                  <li>Status:</li>
                  <li>{playingQuestionSectionLabel()}</li>
                </ul>
              </div>
            </div>

            <div className="recorded-audio-wrapper">
              <div className="mt-3 clearfix">
                <div className="row">
                  <div className="col-10 col-sm-11">
                    <ProgressBar now={(soundPer)} striped />
                  </div>

                  <div className="col-1">
                    <div className="volume-control-wrapper">
                      <span className="volume-icon">
                        <i className="fa fa-volume-up" aria-hidden="true"></i>
                      </span>
                      <div className="re-volume-wrapper-horizontal">
                        <input
                          type="range"
                          placeholder="Volume"
                          className="volume-control"
                          min="0"
                          max="100"
                          step="1"
                          defaultValue={volume}
                          onInput={changeRange}
                          style={{
                            "--progress": `${(volume / 100) * 100}%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 mt-2 px-0">
                    <div className="mr-2 pull-left visibility-visible">
                      <PlaybackSpeedBtns
                       answer={props.answer}
                        sound = {soundStatus}
                        changePlaybackSpeed={changePlaybackSpeed}
                        playbackSpeed={playbackSpeed}
                      />
                    </div>
                  {defaultSelectedVoice && props.data?.question_audios?.length > 1 && !props.answer && (
                    <div className="mx-1 pull-left visibility-visible">
                      <SelectVoiceDropDown
                        answer={props.answer}
                        sound={soundStatus}
                        voices={props.voices}
                        selected={defaultSelectedVoice}
                        changeAudio={changeAudio}
                      />
                    </div>
                  )}
                    {showSkipAudioWaitButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={skip}
                        >Start Audio</a>
                      </div>
                    }

                     {showSkipAudioButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={stopAudio}
                        >Stop Audio</a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
                    {/* visibility-visible */}
      <div className="radiolist-content custom-box mx-0">
        <h4>{questionText}</h4>
        <div className="radiolist-group">
          {data && !resultMode && data.option.map(function (item, i) {
            return (
              <label className={`radio-wrapper ${optionResponseClass(item)}`} key={i} onDoubleClick={handleDoubleClick}>
                <p>{item.options}</p>
                <input
                  type="radio"
                  name="answer"
                  value={item.id}
                  checked={selectedValue == item.id}
                  onChange={handleChange}
                  disabled={answer ? true : false}
                />
                <span className="checkmark" style={{borderRadius:"50%"}}></span>
              </label>
            )
          })}
        </div>
      </div>
    </>
  );
};

export default McqSingle;